module.exports = __webpack_public_path__ + "media/images/front/banner_minpre_241218-58f461d6a6c3527de5497619d87de128.jpg";